import React from "react";
import "./leftSideFilter.scss";
import {
  TextField,
  Button,
  InputAdornment,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormGroup,
  Checkbox,
} from "@mui/material";
import PrettoPriceSlider from "../../../components/prettoPriceSlider/PrettoPriceSlider";
import { ProductColors, ProductSizes, filterPricing } from "../../../constant";
import { useEffect } from "react";
import filterStore, {
  defaultEndingPrice,
  defaultStartingPrice,
} from "../../../store/filterStore";

const LeftSideFilter = ({ resetFilters, handleChange, allSetFilter }) => {
  const FilterStore = filterStore();
  useEffect(() => {
    if (
      FilterStore.resetColor === false &&
      FilterStore.resetPrice === false &&
      FilterStore.resetSize === false
    ) {
      FilterStore.setResetAll({ value: false });
      allSetFilter();
    }
  }, [FilterStore.resetPrice, FilterStore.resetColor, FilterStore.resetSize]);

  return (
    <div className="leftside-filter-container">
      <div className="title">
        <p>Filters</p>
        <Button
          size="small"
          disabled={!FilterStore.resetAll}
          onClick={resetFilters}
        >
          Clear Filter
        </Button>
      </div>
      <div className="pricing-filter">
        <div className="filter-title">
          <p>Price</p>
          <Button
            size="small"
            disabled={!FilterStore.resetPrice}
            onClick={() => {
              FilterStore.setResetPrice({ value: false });
              FilterStore.setPriceValue({
                value: [defaultStartingPrice, defaultEndingPrice],
              });
              FilterStore.setPriceRadio({ value: "" });
              allSetFilter();
            }}
          >
            Reset
          </Button>
        </div>
        <div className="price-slider">
          <PrettoPriceSlider
            value={FilterStore.priceValue}
            onChange={handleChange}
            max={defaultEndingPrice}
            min={defaultStartingPrice}
            step={50}
          />
        </div>
        <div className="price-text-box">
          <TextField
            className="textField"
            size="small"
            value={FilterStore.priceValue[0]}
            variant="outlined"
            inputProps={{ inputMode: "numeric" }}
            onChange={(e) => {
              if (e.target.value === "") {
                FilterStore.setPriceValue({
                  value: [0, FilterStore.priceValue[1]],
                });
              } else {
                FilterStore.setPriceValue({
                  value: [parseInt(e.target.value), FilterStore.priceValue[1]],
                });
              }
              FilterStore.setPriceRadio({ value: "" });
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">₹</InputAdornment>
              ),
            }}
          />
          <TextField
            className="textField"
            size="small"
            value={FilterStore.priceValue[1]}
            variant="outlined"
            inputProps={{ inputMode: "numeric" }}
            onChange={(e) => {
              if (e.target.value === "") {
                FilterStore.setPriceValue({
                  value: [FilterStore.priceValue[0], 0],
                });
              } else {
                FilterStore.setPriceValue({
                  value: [FilterStore.priceValue[0], parseInt(e.target.value)],
                });
              }
              FilterStore.setPriceRadio({ value: "" });
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">₹</InputAdornment>
              ),
            }}
          />
        </div>
        <div className="other-price-option">
          <RadioGroup
            value={FilterStore.priceRadio}
            onChange={(e) => {
              FilterStore.setPriceRadio({ value: e.target.value });
              let startPrice = 0;
              if (e.target.value.match(defaultEndingPrice)) {
                startPrice = 2000;
              } else {
                startPrice = e.target.value - 500;
              }
              const finishPrice = e.target.value;

              FilterStore.setPriceValue({
                value: [parseInt(startPrice), parseInt(finishPrice)],
              });
            }}
          >
            {filterPricing.map((item, index) => (
              <FormControlLabel
                className="option"
                key={index}
                value={item.value}
                control={<Radio className="icon" size="small" />}
                label={<p>{item.label}</p>}
              />
            ))}
          </RadioGroup>
        </div>
      </div>
      <div className="color-filter">
        <div className="filter-title">
          <p>Color</p>
          <Button
            size="small"
            disabled={!FilterStore.resetColor}
            onClick={() => {
              FilterStore.setResetColor({ value: false });
              FilterStore.setSelectedColors({ value: [] });
              allSetFilter();
            }}
          >
            Reset
          </Button>
        </div>
        <div className="color-options">
          <FormGroup>
            {ProductColors.map((color) => {
              let checked = false;
              for (let i = 0; i < FilterStore.selectedColors.length; i++) {
                if (FilterStore.selectedColors[i] === color) {
                  checked = true;
                }
              }
              return (
                <FormControlLabel
                  className="option"
                  key={color}
                  checked={checked}
                  control={<Checkbox size="small" />}
                  label={<p>{color}</p>}
                  onChange={(e) => {
                    const { checked } = e.target;
                    let data = [...FilterStore.selectedColors];
                    if (checked) {
                      data.push(color);
                    } else {
                      data = FilterStore.selectedColors.filter(
                        (item) => item !== color
                      );
                    }
                    FilterStore.setSelectedColors({ value: data });
                  }}
                />
              );
            })}
          </FormGroup>
        </div>
      </div>
      <div className="size-filter">
        <div className="filter-title">
          <p>Size</p>
          <Button
            size="small"
            disabled={!FilterStore.resetSize}
            onClick={() => {
              FilterStore.setResetSize({ value: false });
              FilterStore.setSelectedSizes({ value: [] });
              allSetFilter();
            }}
          >
            Reset
          </Button>
        </div>
        <div className="size-options">
          <FormGroup>
            {ProductSizes.map((size) => {
              let checked = false;
              for (let i = 0; i < FilterStore.selectedSizes.length; i++) {
                if (FilterStore.selectedSizes[i] === size) {
                  checked = true;
                }
              }
              return (
                <FormControlLabel
                  className="option"
                  key={size}
                  checked={checked}
                  control={<Checkbox size="small" />}
                  label={<p>{size}</p>}
                  onChange={(e) => {
                    const { checked } = e.target;
                    let data = [...FilterStore.selectedSizes];
                    if (checked) {
                      data.push(size);
                    } else {
                      data = FilterStore.selectedSizes.filter(
                        (item) => item !== size
                      );
                    }
                    FilterStore.setSelectedSizes({ value: data });
                  }}
                />
              );
            })}
          </FormGroup>
        </div>
      </div>
    </div>
  );
};

export default LeftSideFilter;
